<section class="join-bg py-20 px-4">
  <div class="max-w-4xl mx-auto text-center flex flex-col items-center">
    <h2 class="text-white text-3xl md:text-5xl font-bold mb-8 leading-tight">
      فرصة تعاقدية ذهبية في قطاع استراتيجي
    </h2>

    <div class="text-white text-xl leading-loose max-w-5xl">
      <p class="mb-1">
        جمهورية مصر العربية تستثمر بقوة في تطوير القطاع الزراعي، ضمن خطط الدولة لتحقيق الأمن الغذائي
      </p>

      <p class="mb-1">
        وزيادة الصادرات الزراعية. هذا التوجه الاستراتيجي يخلق فرصاً تعاقدية حصرية لا تتكرر.
      </p>

      <p class="mb-0 mt-3">
        انضم إلى هذا النمو، واستفد من فرص تعاقدية مدروسة مع شركة تجمع الخبرة الميدانية بالتكنولوجيا
        الحديثة.
      </p>
    </div>

    <button
      (click)="flow.openStart()"
      class="mt-10 rounded-full border border-(--color-main) bg-(--color-secondary) px-14 py-4 text-xl font-bold text-(--color-main) cursor-pointer hover:bg-(--color-main-20) hover:text(--color-main) transition-all duration-300"
    >
      ابدأ التعاقد
    </button>
  </div>
</section>
